import type { BoxProps } from '@mui/material/Box';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

// ----------------------------------------------------------------------

/**
 * Villkorsraden under registreringsformuläret.
 *
 * Texten var mallens engelska "By signing up, I agree to..." med två länkar helt utan href —
 * de pekade ingenstans, och sidorna de påstod sig peka på fanns inte. Nu finns de, och det
 * här är den enda plats i flödet där någon möter dem innan kontot skapas.
 */
export function SignUpTerms({ sx, ...other }: BoxProps) {
  return (
    <Box
      component="span"
      sx={[
        () => ({
          mt: 3,
          display: 'block',
          textAlign: 'center',
          typography: 'caption',
          color: 'text.secondary',
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      {'Genom att skapa ett konto godkänner jag Flinkys '}
      <Link
        component={RouterLink}
        href={paths.villkor}
        underline="always"
        color="text.primary"
      >
        användarvillkor
      </Link>
      {' och har läst '}
      <Link
        component={RouterLink}
        href={paths.integritetspolicy}
        underline="always"
        color="text.primary"
      >
        integritetspolicyn
      </Link>
      .
    </Box>
  );
}
